import { createStore } from 'vuex'
import context from './Modules/context/index'
import theme from './Modules/theme'
import config from './Modules/configPageSpecific'
import { analyticsMiddleware } from 'vue-analytics'

const debug = process.env.NODE_ENV !== 'production'

// Simple logger plugin for Vuex 4
const createLogger = () => (store) => {
  store.subscribe((mutation, state) => {
    if (debug) {
      console.log('Vuex mutation:', mutation.type, mutation.payload)
    }
  })
}

const defaultPlugins = [analyticsMiddleware]

export default createStore({
  modules: {
    context, // Cashier specific
    theme, // Theme specific
    config // Specific for this config page
  },
  strict: debug,
  plugins: debug ? [...defaultPlugins, createLogger()] : defaultPlugins
})
